import { Image, Input, Table, TableColumnsType } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon } from "components/Table";
import Action from "./components/Action";
import { IDriver } from "models/driver";
import useReportRequest from "hooks/reportRequests/useReportRequest";
import { IReportRequest } from "models/reportRequest";
import moment from "moment";
import { AlertContextProvider } from "./components/AlertContext";
import Status from "./components/Status";

export default function ReportRequest() {
  const {
    data: { data, loading, page, per_page, search, total },
    handleSearch,
    handlePageChange,
  } = useReportRequest();

  return (
    <AlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse justify-end">
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </AlertContextProvider>
  );
}

const columns: TableColumnsType<IReportRequest> = [
  {
    title: "Driver Photo",
    dataIndex: "driver",
    render: (driver: IDriver) => (
      <Image
        height={60}
        width={60}
        className="rounded object-cover"
        src={driver.image}
        preview={false}
      />
    ),
  },
  {
    title: "Driver Name",
    dataIndex: "driver",
    sortIcon,
    render: (driver: IDriver) => (
      <p>
        {driver?.first_name} {driver?.middle_name} {driver?.last_name}
      </p>
    ),
  },
  {
    title: "Start Date",
    dataIndex: "started_at",
    render: (value: Date) => <p>{value ? moment(value).format("ll") : "-"}</p>,
  },
  {
    title: "End At",
    dataIndex: "ended_at",
    render: (value: Date) => <p>{value ? moment(value).format("ll") : "-"}</p>,
  },
  {
    title: "Reason",
    dataIndex: "reason",
  },
  {
    title: "Status",
    dataIndex: "status",
    render: Status,
  },
  {
    title: "Status Changed By",
    dataIndex: "status_changed_account",
    render: (value: any) => (
      <p>
        {value?.first_name} {value?.last_name}
      </p>
    ),
  },
  {
    title: "Status Changed At",
    dataIndex: "status_changed_at",
    render: (value: string) => (
      <p>{value ? moment(value).format("ll") : "-"}</p>
    ),
  },
  {
    title: "Declined Reason",
    dataIndex: "declined_reason",
  },
  {
    title: "Action",
    render: (value: IReportRequest) => <Action report={value} />,
  },
];
